import { ReactNode } from 'react';

import { cn } from '@lib/utils';

interface OvalProps {
  children?: ReactNode;
  className?: string;
}

export default function Oval({ children, className }: OvalProps) {
  const baseClassName =
    'absolute bottom-0 left-0 right-0 top-auto flex h-[348px] items-center justify-center overflow-hidden rounded-[999px_0_0_999px] md:bottom-auto md:left-auto md:right-0 md:top-0 md:inline-flex md:h-[720px] z-[1]';

  return <div className={cn(baseClassName, className)}>{children}</div>;
}
